import { fetch } from '@/plugin/axios/index.js'

/**
 * 获取权限
 */
export function getPermissions() {
  return fetch({
    url: '/auth/auth/getPermissions',
    method: 'GET'
  })
}


/**
 * 获取字典
 * @param {Object} params 
 */
export function getDictionaryList(params) {
  return fetch({
    url: '/auth/dictionary/getDictionaryList',
    method: 'GET',
    params
  })
}


/**
 * 获取授权应用
 * @param {Object} params 
 */
export function getAppTypeList() {
  return fetch({
    url: '/auth/user/appTypeList',
    method: 'GET'
  })
}


/**
 * 搜索城市
 * @param {Object} params 
 */
export function getCityList(params) {
	return fetch({
		url: '/district/city',
		method: 'GET',
		params
	})
}


/**
 * 获得省市区接口
 * @param {Object} params 
 */
export function district(param) {
	return fetch({
		url: '/auth/district/children?parentId=' + param,
		method: 'GET'
	})
}


/**
 * @param {Object} data
 * 导入记录
 */
export function importList(data) {
  return fetch({
    url: '/auth/importLog/importList',
    method: 'POST',
    data
  })
}

/**
 * 上传附件
 * 
 */
export function uploadFile(data) {
  return fetch({
    url: '/foreign/storage/uploadFile',
    method: 'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Sys/index.js